import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

// import { parseCookies } from '@/helper'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: 'not-found',
    meta: {
      layout: 'ClearLayout'
    },
    component: () => import(/* webpackChunkName: "404" */ '../routes/404')
  },
  {
    path: '/auth',
    name: 'auth',
    meta: {
      layout: 'ClearLayout'
    },
    component: () => import(/* webpackChunkName: "auth" */ '../routes/auth')
  },
  {
    path: '/',
    name: 'dashboard',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '../routes/dashboard')
  },
  {
    path: '/product',
    name: 'product',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "product" */ '../routes/product')
  },
  {
    path: '/category',
    name: 'category',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "category" */ '../routes/category')
  },
  {
    path: '/online-order',
    name: 'onlineOrder',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "online-order" */ '../routes/onlineOrder')
  },
  {
    path: '/users',
    name: 'users',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "users" */ '../routes/users')
  },
  {
    path: '/sale',
    name: 'sale',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    layout: 'DefaultLayout',
    component: () => import(/* webpackChunkName: "sale" */ '../routes/sale')
  },
  {
    path: '/sale/users',
    name: 'saleUsers',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "sale-users" */ '../routes/sale/users')
  },
  {
    path: '/sale/returned',
    name: 'saleReturned',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "sale-returned" */ '../routes/sale/returned')
  },
  {
    path: '/sale/statistic',
    name: 'saleStatistic',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "sale-statistic" */ '../routes/sale/statistic')
  },
  {
    path: '/cash-operation',
    name: 'cashOperation',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "cashOperation" */ '../routes/cashOperation')
  },
  {
    path: '/bar-codes',
    name: 'barCodes',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "barCodes" */ '../routes/barCodes')
  },
  {
    path: '/inventory',
    name: 'inventory',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "inventory" */ '../routes/inventory')
  },
  {
    path: '/working-shift',
    name: 'workingShift',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "workingShift" */ '../routes/workingShift')
  },
  {
    path: '/history',
    name: 'history',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "history" */ '../routes/history')
  },
  {
    path: '/user/settings',
    name: 'userSettings',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true
    },
    component: () => import(/* webpackChunkName: "user-settings" */ '../routes/userSettings')
  },
  {
    path: '/settings',
    name: 'settings',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "settings" */ '../routes/settings')
  },
  {
    path: '/repair',
    name: 'repair',
    meta: {
      layout: 'DefaultLayout',
      onlyAuth: true,
    },
    component: () => import(/* webpackChunkName: "repair" */ '../routes/repair')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const isOnlyAuth = to.matched.some(record => record.meta.onlyAuth)

  const isAuthorized = store.getters['user/isAuth']

  if (isOnlyAuth && !isAuthorized) {
    next('/auth')
  } else {
    next()
  }
})

export default router
